(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const initializedGalleries = new WeakSet();

  const initGallery = (gallery) => {
    if (initializedGalleries.has(gallery)) return;
    initializedGalleries.add(gallery);

    const slider = gallery.querySelector('.product__media-list');
    if (!slider) return;

    let trackingTouch = false;
    let startX = 0;
    let startY = 0;

    gallery.querySelectorAll('.product__media img').forEach((image) => {
      image.setAttribute('draggable', 'false');
    });

    slider.addEventListener(
      'touchstart',
      (event) => {
        if (!mobile.matches || event.touches.length !== 1) {
          trackingTouch = false;
          return;
        }

        trackingTouch = true;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      (event) => {
        if (!trackingTouch || !mobile.matches || event.touches.length !== 1) return;

        const deltaX = event.touches[0].clientX - startX;
        const deltaY = event.touches[0].clientY - startY;
        const isVerticalGesture = Math.abs(deltaY) > Math.abs(deltaX);

        if (isVerticalGesture && event.cancelable) {
          event.preventDefault();
        }
      },
      { capture: true, passive: false }
    );

    const stopTracking = () => {
      trackingTouch = false;
    };

    slider.addEventListener('touchend', stopTracking, { passive: true });
    slider.addEventListener('touchcancel', stopTracking, { passive: true });
    gallery.addEventListener('dragstart', (event) => event.preventDefault());
  };

  const initGalleries = (root = document) => {
    root.querySelectorAll('.new-design-product media-gallery').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGalleries(), { once: true });
  } else {
    initGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => initGalleries(event.target));
  document.addEventListener('product-info:loaded', () => initGalleries());
})();
